import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonBase from '@/design-system/atoms/buttons/ButtonBase.vue'
import { ref } from 'vue'
interface EMITS {
  (e: 'onClicked', event: Event): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonText',
  props: {
    buttonText: { default: '' },
    disabled: { type: Boolean, default: false },
    iconLeft: { default: '' },
    iconRight: { default: '' },
    size: { default: 'medium' }
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props
let hover = ref(false)
const emits = __emit

function hoverButtonEnter() {
  if (props.disabled) return
  hover.value = true
}
function hoverButtonLeave() {
  hover.value = false
}
function onClicked(event: Event) {
  if (!props.disabled) {
    emits('onClicked', event)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonBase, {
    buttonText: _ctx.buttonText,
    class: _normalizeClass({
      'button-text': !_ctx.disabled,
      small: _ctx.size === 'extra-small' || _ctx.size === 'small' || _ctx.size === 'extra-small-icon'
    }),
    disabled: _ctx.disabled,
    iconLeft: _ctx.iconLeft,
    iconRight: _ctx.iconRight,
    size: _ctx.size,
    whiteContent: _unref(hover),
    onOnClicked: onClicked,
    onMouseenter: hoverButtonEnter,
    onMouseleave: hoverButtonLeave
  }, {
    left: _withCtx(() => [
      _renderSlot(_ctx.$slots, "left")
    ]),
    right: _withCtx(() => [
      _renderSlot(_ctx.$slots, "right")
    ]),
    _: 3
  }, 8, ["buttonText", "class", "disabled", "iconLeft", "iconRight", "size", "whiteContent"]))
}
}

})